import React from 'react'

import { SIconSpan } from '../../styles/Icons'

export function RefreshIcon({ size = 22, color, title, id }: IIConProps): React.ReactElement {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                fill={color ?? 'currentcolor'}
                width="100%"
                height="100%"
                viewBox="0 0 20 18"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_5691_11918)">
                    <path d="M18.1013 11.7838L16.0408 12.4308C15.2746 12.6778 14.3891 12.2095 14.1507 11.4432L13.5036 9.37422L11.6049 8.37805L12.7033 11.8944C12.9502 12.6607 13.4695 13.2993 14.1847 13.6739C14.8999 14.0485 15.7173 14.1167 16.4921 13.8868L20.0085 12.7884L18.1098 11.7923L18.1013 11.7838Z" />
                    <path d="M16.9263 7.13493C16.1601 2.49466 11.7582 -0.655621 7.13494 0.119177C2.49466 0.885461 -0.647098 5.27882 0.110671 9.91058C0.791812 14.0059 4.37632 17.0285 8.51425 17.0285C8.6079 17.0285 8.69305 17.0285 8.7867 17.0285H8.98253V15.0958H8.76968C8.68453 15.1043 8.59939 15.1128 8.51425 15.1128C5.31288 15.1128 2.53724 12.7884 2.00935 9.60406C1.71987 7.86716 2.12855 6.12173 3.15878 4.69134C4.189 3.26094 5.70454 2.30734 7.44145 2.01786C11.0174 1.42186 14.4317 3.85694 15.0277 7.44996C15.2831 8.99104 14.9766 10.5747 14.1677 11.9199L14.0741 12.0732L15.547 13.3248L15.6747 13.129C16.8242 11.341 17.2669 9.22092 16.9263 7.14344V7.13493Z" />
                </g>
                <defs>
                    <clipPath id="clip0_5691_11918">
                        <rect width="20" height="17.0285" />
                    </clipPath>
                </defs>
            </svg>
        </SIconSpan>
    )
}
